/**
 * 本文件由 scripts/generate-spm-codes.mjs 生成，请勿手改；编码以评审确认后的 CSV 快照为准。
 * 页面终端：home_pc（360 个 D 位坑位，19 个 C 位模块）。
 * 曝光事件上报模块编码（module.code，A.B.C）；点击事件上报坑位完整编码（A.B.C.D）。
 */
import type { SpmPageCodes } from '../types';
import { getSpmSitePrefix } from '../site';

const sitePrefix = getSpmSitePrefix();

export const HOME_PC_SPM_CODES = {
  best_sellers: {
    code: `${sitePrefix}.home_pc.best_sellers`,
    next: `${sitePrefix}.home_pc.best_sellers.next`,
    open_featured_product: `${sitePrefix}.home_pc.best_sellers.open_featured_product`,
    previous: `${sitePrefix}.home_pc.best_sellers.previous`,
    select_next_product: `${sitePrefix}.home_pc.best_sellers.select_next_product`,
    select_previous_product: `${sitePrefix}.home_pc.best_sellers.select_previous_product`,
    shop_featured_product: `${sitePrefix}.home_pc.best_sellers.shop_featured_product`,
    tab_option_01: `${sitePrefix}.home_pc.best_sellers.tab_option_01`,
    tab_option_02: `${sitePrefix}.home_pc.best_sellers.tab_option_02`,
    view_more: `${sitePrefix}.home_pc.best_sellers.view_more`,
  },
  eyewear_inspiration: {
    code: `${sitePrefix}.home_pc.eyewear_inspiration`,
    color_swatch_001_01: `${sitePrefix}.home_pc.eyewear_inspiration.color_swatch_001_01`,
    color_swatch_001_02: `${sitePrefix}.home_pc.eyewear_inspiration.color_swatch_001_02`,
    color_swatch_001_03: `${sitePrefix}.home_pc.eyewear_inspiration.color_swatch_001_03`,
    color_swatch_001_04: `${sitePrefix}.home_pc.eyewear_inspiration.color_swatch_001_04`,
    color_swatch_001_05: `${sitePrefix}.home_pc.eyewear_inspiration.color_swatch_001_05`,
    color_swatch_001_06: `${sitePrefix}.home_pc.eyewear_inspiration.color_swatch_001_06`,
    color_swatch_002_01: `${sitePrefix}.home_pc.eyewear_inspiration.color_swatch_002_01`,
    color_swatch_002_02: `${sitePrefix}.home_pc.eyewear_inspiration.color_swatch_002_02`,
    color_swatch_003_01: `${sitePrefix}.home_pc.eyewear_inspiration.color_swatch_003_01`,
    color_swatch_003_02: `${sitePrefix}.home_pc.eyewear_inspiration.color_swatch_003_02`,
    color_swatch_003_03: `${sitePrefix}.home_pc.eyewear_inspiration.color_swatch_003_03`,
    color_swatch_003_04: `${sitePrefix}.home_pc.eyewear_inspiration.color_swatch_003_04`,
    color_swatch_003_05: `${sitePrefix}.home_pc.eyewear_inspiration.color_swatch_003_05`,
    color_swatch_003_06: `${sitePrefix}.home_pc.eyewear_inspiration.color_swatch_003_06`,
    color_swatch_004_01: `${sitePrefix}.home_pc.eyewear_inspiration.color_swatch_004_01`,
    color_swatch_004_02: `${sitePrefix}.home_pc.eyewear_inspiration.color_swatch_004_02`,
    color_swatch_004_03: `${sitePrefix}.home_pc.eyewear_inspiration.color_swatch_004_03`,
    color_swatch_004_04: `${sitePrefix}.home_pc.eyewear_inspiration.color_swatch_004_04`,
    color_swatch_005_01: `${sitePrefix}.home_pc.eyewear_inspiration.color_swatch_005_01`,
    color_swatch_005_02: `${sitePrefix}.home_pc.eyewear_inspiration.color_swatch_005_02`,
    color_swatch_005_03: `${sitePrefix}.home_pc.eyewear_inspiration.color_swatch_005_03`,
    color_swatch_005_04: `${sitePrefix}.home_pc.eyewear_inspiration.color_swatch_005_04`,
    color_swatch_005_05: `${sitePrefix}.home_pc.eyewear_inspiration.color_swatch_005_05`,
    color_swatch_005_06: `${sitePrefix}.home_pc.eyewear_inspiration.color_swatch_005_06`,
    favorite_001: `${sitePrefix}.home_pc.eyewear_inspiration.favorite_001`,
    favorite_002: `${sitePrefix}.home_pc.eyewear_inspiration.favorite_002`,
    favorite_003: `${sitePrefix}.home_pc.eyewear_inspiration.favorite_003`,
    favorite_004: `${sitePrefix}.home_pc.eyewear_inspiration.favorite_004`,
    favorite_005: `${sitePrefix}.home_pc.eyewear_inspiration.favorite_005`,
    next: `${sitePrefix}.home_pc.eyewear_inspiration.next`,
    open_campaign: `${sitePrefix}.home_pc.eyewear_inspiration.open_campaign`,
    previous: `${sitePrefix}.home_pc.eyewear_inspiration.previous`,
    product_001: `${sitePrefix}.home_pc.eyewear_inspiration.product_001`,
    product_002: `${sitePrefix}.home_pc.eyewear_inspiration.product_002`,
    product_003: `${sitePrefix}.home_pc.eyewear_inspiration.product_003`,
    product_004: `${sitePrefix}.home_pc.eyewear_inspiration.product_004`,
    product_005: `${sitePrefix}.home_pc.eyewear_inspiration.product_005`,
  },
  footer_country_sites: {
    code: `${sitePrefix}.home_pc.footer_country_sites`,
    country_site_entry_001: `${sitePrefix}.home_pc.footer_country_sites.country_site_entry_001`,
    country_site_entry_002: `${sitePrefix}.home_pc.footer_country_sites.country_site_entry_002`,
    country_site_entry_003: `${sitePrefix}.home_pc.footer_country_sites.country_site_entry_003`,
    country_site_entry_004: `${sitePrefix}.home_pc.footer_country_sites.country_site_entry_004`,
    country_site_entry_005: `${sitePrefix}.home_pc.footer_country_sites.country_site_entry_005`,
  },
  footer_help: {
    code: `${sitePrefix}.home_pc.footer_help`,
    open_contact_us: `${sitePrefix}.home_pc.footer_help.open_contact_us`,
    open_market_zeelool_com: `${sitePrefix}.home_pc.footer_help.open_market_zeelool_com`,
    open_track_order: `${sitePrefix}.home_pc.footer_help.open_track_order`,
  },
  footer_navigation: {
    code: `${sitePrefix}.home_pc.footer_navigation`,
    footer_link_01: `${sitePrefix}.home_pc.footer_navigation.footer_link_01`,
    footer_link_02: `${sitePrefix}.home_pc.footer_navigation.footer_link_02`,
    footer_link_03: `${sitePrefix}.home_pc.footer_navigation.footer_link_03`,
    footer_link_04: `${sitePrefix}.home_pc.footer_navigation.footer_link_04`,
    footer_link_05: `${sitePrefix}.home_pc.footer_navigation.footer_link_05`,
    footer_link_06: `${sitePrefix}.home_pc.footer_navigation.footer_link_06`,
    footer_link_07: `${sitePrefix}.home_pc.footer_navigation.footer_link_07`,
    footer_link_08: `${sitePrefix}.home_pc.footer_navigation.footer_link_08`,
    footer_link_09: `${sitePrefix}.home_pc.footer_navigation.footer_link_09`,
    footer_link_10: `${sitePrefix}.home_pc.footer_navigation.footer_link_10`,
    footer_link_11: `${sitePrefix}.home_pc.footer_navigation.footer_link_11`,
    footer_link_12: `${sitePrefix}.home_pc.footer_navigation.footer_link_12`,
    footer_link_13: `${sitePrefix}.home_pc.footer_navigation.footer_link_13`,
    footer_link_14: `${sitePrefix}.home_pc.footer_navigation.footer_link_14`,
    footer_link_15: `${sitePrefix}.home_pc.footer_navigation.footer_link_15`,
    footer_link_16: `${sitePrefix}.home_pc.footer_navigation.footer_link_16`,
    footer_link_17: `${sitePrefix}.home_pc.footer_navigation.footer_link_17`,
    footer_link_18: `${sitePrefix}.home_pc.footer_navigation.footer_link_18`,
    footer_link_19: `${sitePrefix}.home_pc.footer_navigation.footer_link_19`,
    footer_link_20: `${sitePrefix}.home_pc.footer_navigation.footer_link_20`,
    footer_link_21: `${sitePrefix}.home_pc.footer_navigation.footer_link_21`,
    footer_link_22: `${sitePrefix}.home_pc.footer_navigation.footer_link_22`,
    footer_link_23: `${sitePrefix}.home_pc.footer_navigation.footer_link_23`,
    footer_link_24: `${sitePrefix}.home_pc.footer_navigation.footer_link_24`,
    footer_link_25: `${sitePrefix}.home_pc.footer_navigation.footer_link_25`,
    footer_link_26: `${sitePrefix}.home_pc.footer_navigation.footer_link_26`,
    footer_link_27: `${sitePrefix}.home_pc.footer_navigation.footer_link_27`,
    footer_link_28: `${sitePrefix}.home_pc.footer_navigation.footer_link_28`,
    footer_link_29: `${sitePrefix}.home_pc.footer_navigation.footer_link_29`,
    footer_link_30: `${sitePrefix}.home_pc.footer_navigation.footer_link_30`,
    footer_link_31: `${sitePrefix}.home_pc.footer_navigation.footer_link_31`,
    footer_link_32: `${sitePrefix}.home_pc.footer_navigation.footer_link_32`,
    footer_link_33: `${sitePrefix}.home_pc.footer_navigation.footer_link_33`,
    footer_link_34: `${sitePrefix}.home_pc.footer_navigation.footer_link_34`,
    footer_link_35: `${sitePrefix}.home_pc.footer_navigation.footer_link_35`,
    footer_link_36: `${sitePrefix}.home_pc.footer_navigation.footer_link_36`,
    footer_link_37: `${sitePrefix}.home_pc.footer_navigation.footer_link_37`,
    footer_link_38: `${sitePrefix}.home_pc.footer_navigation.footer_link_38`,
    footer_link_39: `${sitePrefix}.home_pc.footer_navigation.footer_link_39`,
    footer_link_40: `${sitePrefix}.home_pc.footer_navigation.footer_link_40`,
    footer_link_41: `${sitePrefix}.home_pc.footer_navigation.footer_link_41`,
    footer_link_42: `${sitePrefix}.home_pc.footer_navigation.footer_link_42`,
    footer_link_43: `${sitePrefix}.home_pc.footer_navigation.footer_link_43`,
    footer_link_44: `${sitePrefix}.home_pc.footer_navigation.footer_link_44`,
    footer_link_45: `${sitePrefix}.home_pc.footer_navigation.footer_link_45`,
    footer_link_46: `${sitePrefix}.home_pc.footer_navigation.footer_link_46`,
    footer_link_47: `${sitePrefix}.home_pc.footer_navigation.footer_link_47`,
    footer_link_48: `${sitePrefix}.home_pc.footer_navigation.footer_link_48`,
    footer_link_49: `${sitePrefix}.home_pc.footer_navigation.footer_link_49`,
    footer_link_50: `${sitePrefix}.home_pc.footer_navigation.footer_link_50`,
    footer_link_51: `${sitePrefix}.home_pc.footer_navigation.footer_link_51`,
    footer_link_52: `${sitePrefix}.home_pc.footer_navigation.footer_link_52`,
    footer_link_53: `${sitePrefix}.home_pc.footer_navigation.footer_link_53`,
    footer_link_54: `${sitePrefix}.home_pc.footer_navigation.footer_link_54`,
    footer_link_55: `${sitePrefix}.home_pc.footer_navigation.footer_link_55`,
    footer_link_56: `${sitePrefix}.home_pc.footer_navigation.footer_link_56`,
    footer_link_57: `${sitePrefix}.home_pc.footer_navigation.footer_link_57`,
    footer_link_58: `${sitePrefix}.home_pc.footer_navigation.footer_link_58`,
    footer_link_59: `${sitePrefix}.home_pc.footer_navigation.footer_link_59`,
    footer_link_60: `${sitePrefix}.home_pc.footer_navigation.footer_link_60`,
    footer_link_61: `${sitePrefix}.home_pc.footer_navigation.footer_link_61`,
    footer_link_62: `${sitePrefix}.home_pc.footer_navigation.footer_link_62`,
    footer_link_63: `${sitePrefix}.home_pc.footer_navigation.footer_link_63`,
    footer_link_64: `${sitePrefix}.home_pc.footer_navigation.footer_link_64`,
    footer_link_65: `${sitePrefix}.home_pc.footer_navigation.footer_link_65`,
    footer_link_66: `${sitePrefix}.home_pc.footer_navigation.footer_link_66`,
    footer_link_67: `${sitePrefix}.home_pc.footer_navigation.footer_link_67`,
    footer_link_68: `${sitePrefix}.home_pc.footer_navigation.footer_link_68`,
    footer_link_69: `${sitePrefix}.home_pc.footer_navigation.footer_link_69`,
    footer_link_70: `${sitePrefix}.home_pc.footer_navigation.footer_link_70`,
    footer_link_71: `${sitePrefix}.home_pc.footer_navigation.footer_link_71`,
    footer_link_72: `${sitePrefix}.home_pc.footer_navigation.footer_link_72`,
    footer_link_73: `${sitePrefix}.home_pc.footer_navigation.footer_link_73`,
    footer_link_74: `${sitePrefix}.home_pc.footer_navigation.footer_link_74`,
    footer_link_75: `${sitePrefix}.home_pc.footer_navigation.footer_link_75`,
    footer_link_76: `${sitePrefix}.home_pc.footer_navigation.footer_link_76`,
    footer_link_77: `${sitePrefix}.home_pc.footer_navigation.footer_link_77`,
  },
  footer_policies: {
    code: `${sitePrefix}.home_pc.footer_policies`,
    policy_entry_01: `${sitePrefix}.home_pc.footer_policies.policy_entry_01`,
    policy_entry_02: `${sitePrefix}.home_pc.footer_policies.policy_entry_02`,
    policy_entry_03: `${sitePrefix}.home_pc.footer_policies.policy_entry_03`,
    policy_entry_04: `${sitePrefix}.home_pc.footer_policies.policy_entry_04`,
    policy_entry_05: `${sitePrefix}.home_pc.footer_policies.policy_entry_05`,
    policy_entry_06: `${sitePrefix}.home_pc.footer_policies.policy_entry_06`,
  },
  footer_social: {
    code: `${sitePrefix}.home_pc.footer_social`,
    social_entry_01: `${sitePrefix}.home_pc.footer_social.social_entry_01`,
    social_entry_02: `${sitePrefix}.home_pc.footer_social.social_entry_02`,
    social_entry_03: `${sitePrefix}.home_pc.footer_social.social_entry_03`,
    social_entry_04: `${sitePrefix}.home_pc.footer_social.social_entry_04`,
    social_entry_05: `${sitePrefix}.home_pc.footer_social.social_entry_05`,
    social_entry_06: `${sitePrefix}.home_pc.footer_social.social_entry_06`,
    social_entry_07: `${sitePrefix}.home_pc.footer_social.social_entry_07`,
  },
  footer_subscribe: {
    code: `${sitePrefix}.home_pc.footer_subscribe`,
    email_input: `${sitePrefix}.home_pc.footer_subscribe.email_input`,
    submit_subscription: `${sitePrefix}.home_pc.footer_subscribe.submit_subscription`,
  },
  header_tools: {
    code: `${sitePrefix}.home_pc.header_tools`,
    cart_entry: `${sitePrefix}.home_pc.header_tools.cart_entry`,
    open_account: `${sitePrefix}.home_pc.header_tools.open_account`,
    open_wishlist: `${sitePrefix}.home_pc.header_tools.open_wishlist`,
    search_input: `${sitePrefix}.home_pc.header_tools.search_input`,
    search_submit: `${sitePrefix}.home_pc.header_tools.search_submit`,
  },
  hero_banner: {
    code: `${sitePrefix}.home_pc.hero_banner`,
    banner_01: `${sitePrefix}.home_pc.hero_banner.banner_01`,
    banner_02: `${sitePrefix}.home_pc.hero_banner.banner_02`,
    banner_03: `${sitePrefix}.home_pc.hero_banner.banner_03`,
    slide_indicator_01: `${sitePrefix}.home_pc.hero_banner.slide_indicator_01`,
    slide_indicator_02: `${sitePrefix}.home_pc.hero_banner.slide_indicator_02`,
    slide_indicator_03: `${sitePrefix}.home_pc.hero_banner.slide_indicator_03`,
  },
  new_arrivals: {
    code: `${sitePrefix}.home_pc.new_arrivals`,
    color_swatch_001_01: `${sitePrefix}.home_pc.new_arrivals.color_swatch_001_01`,
    color_swatch_001_02: `${sitePrefix}.home_pc.new_arrivals.color_swatch_001_02`,
    color_swatch_001_03: `${sitePrefix}.home_pc.new_arrivals.color_swatch_001_03`,
    color_swatch_002_01: `${sitePrefix}.home_pc.new_arrivals.color_swatch_002_01`,
    color_swatch_002_02: `${sitePrefix}.home_pc.new_arrivals.color_swatch_002_02`,
    color_swatch_002_03: `${sitePrefix}.home_pc.new_arrivals.color_swatch_002_03`,
    color_swatch_003_01: `${sitePrefix}.home_pc.new_arrivals.color_swatch_003_01`,
    color_swatch_003_02: `${sitePrefix}.home_pc.new_arrivals.color_swatch_003_02`,
    color_swatch_003_03: `${sitePrefix}.home_pc.new_arrivals.color_swatch_003_03`,
    color_swatch_004_01: `${sitePrefix}.home_pc.new_arrivals.color_swatch_004_01`,
    color_swatch_004_02: `${sitePrefix}.home_pc.new_arrivals.color_swatch_004_02`,
    color_swatch_004_03: `${sitePrefix}.home_pc.new_arrivals.color_swatch_004_03`,
    color_swatch_005_01: `${sitePrefix}.home_pc.new_arrivals.color_swatch_005_01`,
    color_swatch_005_02: `${sitePrefix}.home_pc.new_arrivals.color_swatch_005_02`,
    color_swatch_005_03: `${sitePrefix}.home_pc.new_arrivals.color_swatch_005_03`,
    color_swatch_006_01: `${sitePrefix}.home_pc.new_arrivals.color_swatch_006_01`,
    color_swatch_006_02: `${sitePrefix}.home_pc.new_arrivals.color_swatch_006_02`,
    color_swatch_006_03: `${sitePrefix}.home_pc.new_arrivals.color_swatch_006_03`,
    color_swatch_007_01: `${sitePrefix}.home_pc.new_arrivals.color_swatch_007_01`,
    color_swatch_007_02: `${sitePrefix}.home_pc.new_arrivals.color_swatch_007_02`,
    color_swatch_007_03: `${sitePrefix}.home_pc.new_arrivals.color_swatch_007_03`,
    color_swatch_008_01: `${sitePrefix}.home_pc.new_arrivals.color_swatch_008_01`,
    color_swatch_008_02: `${sitePrefix}.home_pc.new_arrivals.color_swatch_008_02`,
    color_swatch_008_03: `${sitePrefix}.home_pc.new_arrivals.color_swatch_008_03`,
    color_swatch_009_01: `${sitePrefix}.home_pc.new_arrivals.color_swatch_009_01`,
    color_swatch_009_02: `${sitePrefix}.home_pc.new_arrivals.color_swatch_009_02`,
    color_swatch_009_03: `${sitePrefix}.home_pc.new_arrivals.color_swatch_009_03`,
    color_swatch_010_01: `${sitePrefix}.home_pc.new_arrivals.color_swatch_010_01`,
    color_swatch_010_02: `${sitePrefix}.home_pc.new_arrivals.color_swatch_010_02`,
    color_swatch_010_03: `${sitePrefix}.home_pc.new_arrivals.color_swatch_010_03`,
    color_swatch_010_04: `${sitePrefix}.home_pc.new_arrivals.color_swatch_010_04`,
    color_swatch_011_01: `${sitePrefix}.home_pc.new_arrivals.color_swatch_011_01`,
    color_swatch_011_02: `${sitePrefix}.home_pc.new_arrivals.color_swatch_011_02`,
    color_swatch_011_03: `${sitePrefix}.home_pc.new_arrivals.color_swatch_011_03`,
    color_swatch_012_01: `${sitePrefix}.home_pc.new_arrivals.color_swatch_012_01`,
    color_swatch_012_02: `${sitePrefix}.home_pc.new_arrivals.color_swatch_012_02`,
    color_swatch_012_03: `${sitePrefix}.home_pc.new_arrivals.color_swatch_012_03`,
    favorite_001: `${sitePrefix}.home_pc.new_arrivals.favorite_001`,
    favorite_002: `${sitePrefix}.home_pc.new_arrivals.favorite_002`,
    favorite_003: `${sitePrefix}.home_pc.new_arrivals.favorite_003`,
    favorite_004: `${sitePrefix}.home_pc.new_arrivals.favorite_004`,
    favorite_005: `${sitePrefix}.home_pc.new_arrivals.favorite_005`,
    favorite_006: `${sitePrefix}.home_pc.new_arrivals.favorite_006`,
    favorite_007: `${sitePrefix}.home_pc.new_arrivals.favorite_007`,
    favorite_008: `${sitePrefix}.home_pc.new_arrivals.favorite_008`,
    favorite_009: `${sitePrefix}.home_pc.new_arrivals.favorite_009`,
    favorite_010: `${sitePrefix}.home_pc.new_arrivals.favorite_010`,
    favorite_011: `${sitePrefix}.home_pc.new_arrivals.favorite_011`,
    favorite_012: `${sitePrefix}.home_pc.new_arrivals.favorite_012`,
    open_campaign: `${sitePrefix}.home_pc.new_arrivals.open_campaign`,
    product_001: `${sitePrefix}.home_pc.new_arrivals.product_001`,
    product_002: `${sitePrefix}.home_pc.new_arrivals.product_002`,
    product_003: `${sitePrefix}.home_pc.new_arrivals.product_003`,
    product_004: `${sitePrefix}.home_pc.new_arrivals.product_004`,
    product_005: `${sitePrefix}.home_pc.new_arrivals.product_005`,
    product_006: `${sitePrefix}.home_pc.new_arrivals.product_006`,
    product_007: `${sitePrefix}.home_pc.new_arrivals.product_007`,
    product_008: `${sitePrefix}.home_pc.new_arrivals.product_008`,
    product_009: `${sitePrefix}.home_pc.new_arrivals.product_009`,
    product_010: `${sitePrefix}.home_pc.new_arrivals.product_010`,
    product_011: `${sitePrefix}.home_pc.new_arrivals.product_011`,
    product_012: `${sitePrefix}.home_pc.new_arrivals.product_012`,
  },
  primary_navigation: {
    code: `${sitePrefix}.home_pc.primary_navigation`,
    logo_entry: `${sitePrefix}.home_pc.primary_navigation.logo_entry`,
    nav_item_05: `${sitePrefix}.home_pc.primary_navigation.nav_item_05`,
    nav_item_06: `${sitePrefix}.home_pc.primary_navigation.nav_item_06`,
    scroll_navigation_next: `${sitePrefix}.home_pc.primary_navigation.scroll_navigation_next`,
    scroll_navigation_previous: `${sitePrefix}.home_pc.primary_navigation.scroll_navigation_previous`,
    submenu_item_01_01: `${sitePrefix}.home_pc.primary_navigation.submenu_item_01_01`,
    submenu_item_01_02: `${sitePrefix}.home_pc.primary_navigation.submenu_item_01_02`,
    submenu_item_01_03: `${sitePrefix}.home_pc.primary_navigation.submenu_item_01_03`,
    submenu_item_01_04: `${sitePrefix}.home_pc.primary_navigation.submenu_item_01_04`,
    submenu_item_01_05: `${sitePrefix}.home_pc.primary_navigation.submenu_item_01_05`,
    submenu_item_01_06: `${sitePrefix}.home_pc.primary_navigation.submenu_item_01_06`,
    submenu_item_01_07: `${sitePrefix}.home_pc.primary_navigation.submenu_item_01_07`,
    submenu_item_01_08: `${sitePrefix}.home_pc.primary_navigation.submenu_item_01_08`,
    submenu_item_01_09: `${sitePrefix}.home_pc.primary_navigation.submenu_item_01_09`,
    submenu_item_01_10: `${sitePrefix}.home_pc.primary_navigation.submenu_item_01_10`,
    submenu_item_01_11: `${sitePrefix}.home_pc.primary_navigation.submenu_item_01_11`,
    submenu_item_01_12: `${sitePrefix}.home_pc.primary_navigation.submenu_item_01_12`,
    submenu_item_01_13: `${sitePrefix}.home_pc.primary_navigation.submenu_item_01_13`,
    submenu_item_01_14: `${sitePrefix}.home_pc.primary_navigation.submenu_item_01_14`,
    submenu_item_01_15: `${sitePrefix}.home_pc.primary_navigation.submenu_item_01_15`,
    submenu_item_01_16: `${sitePrefix}.home_pc.primary_navigation.submenu_item_01_16`,
    submenu_item_01_17: `${sitePrefix}.home_pc.primary_navigation.submenu_item_01_17`,
    submenu_item_01_18: `${sitePrefix}.home_pc.primary_navigation.submenu_item_01_18`,
    submenu_item_01_19: `${sitePrefix}.home_pc.primary_navigation.submenu_item_01_19`,
    submenu_item_01_20: `${sitePrefix}.home_pc.primary_navigation.submenu_item_01_20`,
    submenu_item_01_21: `${sitePrefix}.home_pc.primary_navigation.submenu_item_01_21`,
    submenu_item_01_22: `${sitePrefix}.home_pc.primary_navigation.submenu_item_01_22`,
    submenu_item_01_23: `${sitePrefix}.home_pc.primary_navigation.submenu_item_01_23`,
    submenu_item_01_24: `${sitePrefix}.home_pc.primary_navigation.submenu_item_01_24`,
    submenu_item_02_01: `${sitePrefix}.home_pc.primary_navigation.submenu_item_02_01`,
    submenu_item_02_02: `${sitePrefix}.home_pc.primary_navigation.submenu_item_02_02`,
    submenu_item_02_03: `${sitePrefix}.home_pc.primary_navigation.submenu_item_02_03`,
    submenu_item_02_04: `${sitePrefix}.home_pc.primary_navigation.submenu_item_02_04`,
    submenu_item_02_05: `${sitePrefix}.home_pc.primary_navigation.submenu_item_02_05`,
    submenu_item_02_06: `${sitePrefix}.home_pc.primary_navigation.submenu_item_02_06`,
    submenu_item_02_07: `${sitePrefix}.home_pc.primary_navigation.submenu_item_02_07`,
    submenu_item_02_08: `${sitePrefix}.home_pc.primary_navigation.submenu_item_02_08`,
    submenu_item_02_09: `${sitePrefix}.home_pc.primary_navigation.submenu_item_02_09`,
    submenu_item_02_10: `${sitePrefix}.home_pc.primary_navigation.submenu_item_02_10`,
    submenu_item_02_11: `${sitePrefix}.home_pc.primary_navigation.submenu_item_02_11`,
    submenu_item_02_12: `${sitePrefix}.home_pc.primary_navigation.submenu_item_02_12`,
    submenu_item_02_13: `${sitePrefix}.home_pc.primary_navigation.submenu_item_02_13`,
    submenu_item_02_14: `${sitePrefix}.home_pc.primary_navigation.submenu_item_02_14`,
    submenu_item_02_15: `${sitePrefix}.home_pc.primary_navigation.submenu_item_02_15`,
    submenu_item_02_16: `${sitePrefix}.home_pc.primary_navigation.submenu_item_02_16`,
    submenu_item_02_17: `${sitePrefix}.home_pc.primary_navigation.submenu_item_02_17`,
    submenu_item_02_18: `${sitePrefix}.home_pc.primary_navigation.submenu_item_02_18`,
    submenu_item_02_19: `${sitePrefix}.home_pc.primary_navigation.submenu_item_02_19`,
    submenu_item_03_01: `${sitePrefix}.home_pc.primary_navigation.submenu_item_03_01`,
    submenu_item_03_02: `${sitePrefix}.home_pc.primary_navigation.submenu_item_03_02`,
    submenu_item_03_03: `${sitePrefix}.home_pc.primary_navigation.submenu_item_03_03`,
    submenu_item_03_04: `${sitePrefix}.home_pc.primary_navigation.submenu_item_03_04`,
    submenu_item_03_05: `${sitePrefix}.home_pc.primary_navigation.submenu_item_03_05`,
    submenu_item_03_06: `${sitePrefix}.home_pc.primary_navigation.submenu_item_03_06`,
    submenu_item_03_07: `${sitePrefix}.home_pc.primary_navigation.submenu_item_03_07`,
    submenu_item_03_08: `${sitePrefix}.home_pc.primary_navigation.submenu_item_03_08`,
    submenu_item_03_09: `${sitePrefix}.home_pc.primary_navigation.submenu_item_03_09`,
    submenu_item_03_10: `${sitePrefix}.home_pc.primary_navigation.submenu_item_03_10`,
    submenu_item_03_11: `${sitePrefix}.home_pc.primary_navigation.submenu_item_03_11`,
    submenu_item_03_12: `${sitePrefix}.home_pc.primary_navigation.submenu_item_03_12`,
    submenu_item_03_13: `${sitePrefix}.home_pc.primary_navigation.submenu_item_03_13`,
    submenu_item_03_14: `${sitePrefix}.home_pc.primary_navigation.submenu_item_03_14`,
    submenu_item_03_15: `${sitePrefix}.home_pc.primary_navigation.submenu_item_03_15`,
    submenu_item_03_16: `${sitePrefix}.home_pc.primary_navigation.submenu_item_03_16`,
    submenu_item_03_17: `${sitePrefix}.home_pc.primary_navigation.submenu_item_03_17`,
    submenu_item_03_18: `${sitePrefix}.home_pc.primary_navigation.submenu_item_03_18`,
    submenu_item_03_19: `${sitePrefix}.home_pc.primary_navigation.submenu_item_03_19`,
    submenu_item_04_01: `${sitePrefix}.home_pc.primary_navigation.submenu_item_04_01`,
    submenu_item_04_02: `${sitePrefix}.home_pc.primary_navigation.submenu_item_04_02`,
    submenu_item_04_03: `${sitePrefix}.home_pc.primary_navigation.submenu_item_04_03`,
    submenu_item_04_04: `${sitePrefix}.home_pc.primary_navigation.submenu_item_04_04`,
    submenu_item_04_05: `${sitePrefix}.home_pc.primary_navigation.submenu_item_04_05`,
    submenu_item_04_06: `${sitePrefix}.home_pc.primary_navigation.submenu_item_04_06`,
    submenu_item_04_07: `${sitePrefix}.home_pc.primary_navigation.submenu_item_04_07`,
    submenu_item_04_08: `${sitePrefix}.home_pc.primary_navigation.submenu_item_04_08`,
    submenu_item_04_09: `${sitePrefix}.home_pc.primary_navigation.submenu_item_04_09`,
    submenu_item_04_10: `${sitePrefix}.home_pc.primary_navigation.submenu_item_04_10`,
    submenu_item_04_11: `${sitePrefix}.home_pc.primary_navigation.submenu_item_04_11`,
    submenu_item_04_12: `${sitePrefix}.home_pc.primary_navigation.submenu_item_04_12`,
    submenu_item_04_13: `${sitePrefix}.home_pc.primary_navigation.submenu_item_04_13`,
    submenu_item_04_14: `${sitePrefix}.home_pc.primary_navigation.submenu_item_04_14`,
    submenu_item_04_15: `${sitePrefix}.home_pc.primary_navigation.submenu_item_04_15`,
    submenu_item_04_16: `${sitePrefix}.home_pc.primary_navigation.submenu_item_04_16`,
  },
  service_promises: {
    code: `${sitePrefix}.home_pc.service_promises`,
    service_entry_01: `${sitePrefix}.home_pc.service_promises.service_entry_01`,
    service_entry_02: `${sitePrefix}.home_pc.service_promises.service_entry_02`,
    service_entry_03: `${sitePrefix}.home_pc.service_promises.service_entry_03`,
  },
  shop_by_shapes: {
    code: `${sitePrefix}.home_pc.shop_by_shapes`,
    next: `${sitePrefix}.home_pc.shop_by_shapes.next`,
    previous: `${sitePrefix}.home_pc.shop_by_shapes.previous`,
    shape_entry_01: `${sitePrefix}.home_pc.shop_by_shapes.shape_entry_01`,
    shape_entry_02: `${sitePrefix}.home_pc.shop_by_shapes.shape_entry_02`,
    shape_entry_03: `${sitePrefix}.home_pc.shop_by_shapes.shape_entry_03`,
    shape_entry_04: `${sitePrefix}.home_pc.shop_by_shapes.shape_entry_04`,
    shape_entry_05: `${sitePrefix}.home_pc.shop_by_shapes.shape_entry_05`,
    shape_entry_06: `${sitePrefix}.home_pc.shop_by_shapes.shape_entry_06`,
    shape_entry_07: `${sitePrefix}.home_pc.shop_by_shapes.shape_entry_07`,
    shape_entry_08: `${sitePrefix}.home_pc.shop_by_shapes.shape_entry_08`,
    shape_entry_09: `${sitePrefix}.home_pc.shop_by_shapes.shape_entry_09`,
  },
  shop_by_vibes: {
    code: `${sitePrefix}.home_pc.shop_by_vibes`,
    style_entry_01: `${sitePrefix}.home_pc.shop_by_vibes.style_entry_01`,
    style_entry_02: `${sitePrefix}.home_pc.shop_by_vibes.style_entry_02`,
    style_entry_03: `${sitePrefix}.home_pc.shop_by_vibes.style_entry_03`,
    style_entry_04: `${sitePrefix}.home_pc.shop_by_vibes.style_entry_04`,
    style_entry_05: `${sitePrefix}.home_pc.shop_by_vibes.style_entry_05`,
    style_entry_06: `${sitePrefix}.home_pc.shop_by_vibes.style_entry_06`,
  },
  shopping_guide: {
    code: `${sitePrefix}.home_pc.shopping_guide`,
    add_prescription: `${sitePrefix}.home_pc.shopping_guide.add_prescription`,
    after_sales: `${sitePrefix}.home_pc.shopping_guide.after_sales`,
    choose_frames: `${sitePrefix}.home_pc.shopping_guide.choose_frames`,
    customize_lenses: `${sitePrefix}.home_pc.shopping_guide.customize_lenses`,
  },
  site_notice: {
    code: `${sitePrefix}.home_pc.site_notice`,
    open_help_center: `${sitePrefix}.home_pc.site_notice.open_help_center`,
    open_promotion: `${sitePrefix}.home_pc.site_notice.open_promotion`,
    open_site_settings: `${sitePrefix}.home_pc.site_notice.open_site_settings`,
    track_order: `${sitePrefix}.home_pc.site_notice.track_order`,
  },
  site_settings: {
    code: `${sitePrefix}.home_pc.site_settings`,
    country_option_001: `${sitePrefix}.home_pc.site_settings.country_option_001`,
    country_option_002: `${sitePrefix}.home_pc.site_settings.country_option_002`,
    country_option_003: `${sitePrefix}.home_pc.site_settings.country_option_003`,
    country_option_004: `${sitePrefix}.home_pc.site_settings.country_option_004`,
    country_selector: `${sitePrefix}.home_pc.site_settings.country_selector`,
    currency_option_01: `${sitePrefix}.home_pc.site_settings.currency_option_01`,
    currency_option_02: `${sitePrefix}.home_pc.site_settings.currency_option_02`,
    currency_option_03: `${sitePrefix}.home_pc.site_settings.currency_option_03`,
    currency_option_04: `${sitePrefix}.home_pc.site_settings.currency_option_04`,
    currency_option_05: `${sitePrefix}.home_pc.site_settings.currency_option_05`,
    currency_selector: `${sitePrefix}.home_pc.site_settings.currency_selector`,
    language_option_01: `${sitePrefix}.home_pc.site_settings.language_option_01`,
    language_option_02: `${sitePrefix}.home_pc.site_settings.language_option_02`,
    language_option_03: `${sitePrefix}.home_pc.site_settings.language_option_03`,
    language_option_04: `${sitePrefix}.home_pc.site_settings.language_option_04`,
    language_option_05: `${sitePrefix}.home_pc.site_settings.language_option_05`,
    language_option_06: `${sitePrefix}.home_pc.site_settings.language_option_06`,
    language_option_07: `${sitePrefix}.home_pc.site_settings.language_option_07`,
    language_selector: `${sitePrefix}.home_pc.site_settings.language_selector`,
  },
  style_community: {
    code: `${sitePrefix}.home_pc.style_community`,
    explore_more: `${sitePrefix}.home_pc.style_community.explore_more`,
    next: `${sitePrefix}.home_pc.style_community.next`,
    open_creator_gallery_01: `${sitePrefix}.home_pc.style_community.open_creator_gallery_01`,
    open_creator_gallery_02: `${sitePrefix}.home_pc.style_community.open_creator_gallery_02`,
    open_creator_gallery_03: `${sitePrefix}.home_pc.style_community.open_creator_gallery_03`,
    open_creator_gallery_04: `${sitePrefix}.home_pc.style_community.open_creator_gallery_04`,
    open_creator_gallery_05: `${sitePrefix}.home_pc.style_community.open_creator_gallery_05`,
    open_creator_gallery_06: `${sitePrefix}.home_pc.style_community.open_creator_gallery_06`,
    open_creator_gallery_07: `${sitePrefix}.home_pc.style_community.open_creator_gallery_07`,
    open_creator_gallery_08: `${sitePrefix}.home_pc.style_community.open_creator_gallery_08`,
    previous: `${sitePrefix}.home_pc.style_community.previous`,
  },
} as const satisfies SpmPageCodes;
